import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import Error404 from '../../../components/error-404/error-404'

export class Error404Page extends Component {
  render() {
    return (
      <div>
        <Error404 {...this.props} />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(null, mapDispatchToProps)(
  translate()(Error404Page),
)



// WEBPACK FOOTER //
// ./src/containers/pages/error-404-page/error-404-page.js